var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.0046,
    cy: 15.042,
    rx: 12.3913,
    ry: 12.3916,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.967 29.9994C12.0068 29.9994 9.11309 29.1215 6.65179 27.4767C4.19048 25.832 2.27213 23.4943 1.13931 20.7592C0.00649499 18.0242 -0.289909 15.0146 0.287581 12.1111C0.86507 9.20763 2.29052 6.54058 4.38367 4.44723C5.77049 3.04373 7.42111 1.92829 9.24058 1.16508C11.06 0.401862 13.0124 0.00593363 14.9855 6.61848e-05C16.9585 -0.00580126 18.9132 0.378509 20.7372 1.13089C22.5612 1.88327 24.2184 2.98887 25.6135 4.3841C27.0087 5.77933 28.1142 7.43664 28.8665 9.26071C29.6189 11.0848 30.0032 13.0396 29.9973 15.0128C29.9914 16.9859 29.5955 18.9384 28.8324 20.758C28.0692 22.5775 26.9538 24.2283 25.5504 25.6152C24.1638 27.0095 22.5145 28.1149 20.6978 28.8675C18.8812 29.62 16.9334 30.0048 14.967 29.9994ZM10.0881 12.1755V15.616H12.0119V25.4026H16.0586V15.616H18.7291L19.0828 12.1807H16.0586V10.1565C16.0422 10.0363 16.0525 9.91399 16.0886 9.79823C16.1248 9.68248 16.1861 9.5761 16.268 9.48667C16.3499 9.39723 16.4505 9.32692 16.5626 9.28074C16.6747 9.23455 16.7957 9.21361 16.9168 9.21941H19.0925V5.88216L16.0942 5.86952C15.4697 5.82299 14.8433 5.93036 14.27 6.18221C13.6966 6.43406 13.1937 6.82272 12.8055 7.31411C12.2741 8.08999 11.9968 9.01179 12.0119 9.95211V12.1814L10.0881 12.1755Z",
    fill: "#16A02C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0b05c76cdfeb8fdaa78580428c2e8121.svg";
export { ForwardRef as ReactComponent };